import { Tooltip, ToolButton } from '@bst/react-ui';
import { useTranslation } from 'react-i18next';

interface Props {
  hasSearchNotification?: boolean;
  hasAddButton?: boolean;
  handleSearchShow?: () => void;
  disableFilter?: boolean;
}

/**
 * "Find Project" Button with TextTooltip (Home page) for Mobile devices
 * @param Props
 * @returns "Find Project" Button with TextTooltip component (Home page) for Mobile devices
 */
export const MobileSearchButton = ({
  hasSearchNotification,
  handleSearchShow,
  disableFilter,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div className="global-utilities__item u-hide-sm-up">
      <Tooltip content={t("projectHeader_placeholder")}>
        <ToolButton
          id="subheader__search"
          icon="icon-search"
          data-testid="subheader__search"
          aria-label={t("projectHeader_placeholder")}
          disabled={disableFilter}
          onClick={handleSearchShow}
          hasNotification={hasSearchNotification}
        />
      </Tooltip>
    </div>
  );
};
